// Next Level Body Lab brand mark — gold lockup
export default function Logo({ size = "md", subtitle = false }) {
    const sizes = {
        sm: { line1: "text-sm", line2: "text-[10px]" },
        md: { line1: "text-base", line2: "text-xs" },
        lg: { line1: "text-2xl", line2: "text-sm" },
        xl: { line1: "text-5xl", line2: "text-lg" },
    };
    const s = sizes[size] || sizes.md;
    return (
        <div className="inline-flex flex-col items-start" data-testid="brand-logo" aria-label="Next Level Body Lab">
            <span
                className={`font-serif ${s.line1} tracking-[0.32em] gold-gradient-text`}
                style={{ lineHeight: 1 }}
                aria-hidden="true"
            >
                NEXT LEVEL
            </span>
            <span
                className={`font-display ${s.line2} tracking-[0.4em] text-[var(--text-muted)] mt-1.5`}
                style={{ lineHeight: 1 }}
                aria-hidden="true"
            >
                BODY LAB
            </span>
            {subtitle && (
                <span className="font-mono text-[9px] tracking-[0.4em] text-[var(--text-faint)] mt-2">
                    COACH OS
                </span>
            )}
        </div>
    );
}
